import React from "react";
import branch from "recompose/branch";
import BaseNotFound from "./NotFound";
import { Route } from "react-router";

const withEntityNotFound = ({ isFound, NotFoundComponent = BaseNotFound }) => {
  return branch(
    isFound,
    (BaseComponent) => BaseComponent,
    () => (props) =>
      (
        <Route
          render={({ staticContext }) => {
            if (staticContext) {
              staticContext.status = 404;
            }
            return <NotFoundComponent {...props} />;
          }}
        />
      )
  );
};

export default withEntityNotFound;
